import { Button, Typography, useTheme } from "@material-ui/core";
import Image from "next/image";
import { useContext, useState } from "react";
import { TextContext } from "../../../pages/bepaal-statuut";
import DisclaimerModal from "../../footer/DisclaimerModal";
import DisclaimerPreview from "../../footer/DisclaimerPreview";
import StepBody from "../../form-layout/StepBody";
// import undraw_question from "./../../images/undraw_question.svg";
import { SendContext } from "../BepaalStatuut";
import { formEvent } from "config/gtmConfig";

const Welcome = () => {
  const theme = useTheme();
  const send = useContext(SendContext);
  const text = useContext(TextContext);

  const [disclaimerModalOpen, setDisclaimerModalOpen] = useState(false);

  const onStart = () => {
    formEvent({
      eventName: "tool_completed",
      toolName: "ben_ik_zib",
    });
    send({ type: "NEXT" });
  };

  return (
    <div>
      <StepBody roomForNavigationButtons={true}>
        <div style={{ textAlign: "center" }}>
          <Typography
            variant="h2"
            style={{ fontSize: "24pt", marginTop: theme.spacing(2) }}
            gutterBottom
          >
            {text.welcome_title}
          </Typography>
          <Typography
            style={{ color: theme.palette.primary.light, fontSize: "20pt" }}
            variant="h3"
          >
            {text.welcome_subtitle}
          </Typography>
          <div style={{ width: "300px", margin: `${theme.spacing(4)}px auto` }}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth={true}
              onClick={onStart}
            >
              {text.welcome_button}
            </Button>
          </div>
          {/* <img src={undraw_question} style={{ width: "400px",maxWidth:"100%", margin: "50px 0px 50px 0px" }} /> */}
          <div style={{ margin: "20px 0px 20px 0px" }}>
            <Image
              src="/images/undraw_question.svg"
              height="350px"
              width="350px"
            />
          </div>
        </div>
      </StepBody>
      <DisclaimerPreview
        text={text.disclaimerPreview}
        buttonText={text.disclaimerPreview_moreInfoButton}
        setDisclaimerModalOpen={setDisclaimerModalOpen}
      />
      <DisclaimerModal
        text={text.disclaimer}
        closeButtonText={text.disclaimer_closeButton}
        disclaimerModalOpen={disclaimerModalOpen}
        setDisclaimerModalOpen={setDisclaimerModalOpen}
      />
    </div>
  );
};

export default Welcome;
